<template>
  <div>
    <template v-for="(val, key) in comments">
      <div :key="key" class="discussion-box">
        <PostCommentsMenu
          :item="val"
          @editComment="editComment"
          @deleteComment="deleteComment"
          @reportComment="reportComment"
        />
        <DiscussionInput
          :edit="val.edit"
          modeEdit
          v-model="comments[key].text"
          :profile="val.profile"
          :createdDate="val.createdDate"
          :entityId="val.id"
          @onCancel="cancelComment"
          @onSubmit="updateComment"
        />
        <DiscussionPostAction
          :totalLike="val.totalLike"
          :isLiked="val.isLiked"
          :entityId="val.id"
          :entityName="'comment'"
          @onReply="onReply(val)"
          @onLike="onLike"
        />
        <v-divider class="my-6"></v-divider>
      </div>
    </template>
    <InfiniteLoad @loading="onMoreComment" :disabled="endData" />
  </div>
</template>
<script>
import { mergeByKey } from "@/utils/helper";
import DiscussionPostAction from "@/components/Post/Discussion/PostAction";
import PostCommentsMenu from "@/components/Post/Discussion/PostCommentsMenu";
import DiscussionInput from "@/components/Forms/DiscussionInput";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";

export default {
  name: "DiscussionPostComments",
  props: {
    entityId: {},
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DiscussionInput,
    DiscussionPostAction,
    PostCommentsMenu,
    InfiniteLoad,
  },
  data() {
    return {
      comments: [],
      endData: false,
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(val) {
        this.comments = val;
      },
    },
  },
  methods: {
    crudComment(type, val, id) {
      let i = this.comments.findIndex((x) => x.id == id);
      let comment = this.comments[i];
      if (type === "read") {
        return comment;
      } else if (type === "create") {
        this.comments.splice(0, 0, val); //unshift
        let post = { ...this.post };
        post.totalParentComment++;
        post.totalComment++;
        post.comments = this.comments;
        this.post = post;
      } else if (type === "update") {
        const updated = { ...comment, ...val, edit: false };
        this.$set(this.comments, i, updated);
      } else if (type === "edit") {
        this.$set(this.comments[i], "edit", val);
      } else {
        this.comments.splice(i, 1);
        let post = { ...this.post };
        post.totalParentComment--;
        let totalComment = post.totalComment;
        // remove number reply
        const totalReply = comment.totalReply;
        comment.totalReply = 0; // reset
        totalComment = totalComment - totalReply;
        post.totalComment = totalComment > 0 ? --totalComment : 0;
        post.comments = this.comments;
        this.post = post;
      }
      return;
    },
    onReply(val) {
      this.$emit("onReplyComment", val);
    },
    onLike(item) {
      let comment = this.comments.find((x) => x.id == item.id);
      comment.isLiked = item.isLiked;
      if (comment.isLiked) comment.totalLike++;
      else comment.totalLike--;
    },
    cancelComment(id) {
      this.crudComment("edit", false, id);
    },
    editComment(item) {
      this.crudComment("edit", true, item.id);
    },
    updateComment(item) {
      let comment = this.comments.find((x) => x.id == item.id);
      item.isLiked = comment.isLiked;
      this.crudComment("update", item, item.id);
    },
    async deleteComment(id) {
      const result = await this.$store.state.toggle.dialogConfirm.open(
        this.$gettext("Confirm your action"),
        this.$gettext("Do you want to delete this comment ?"),
        { color: "warning" }
      );
      if (!result) return;
      this.crudComment("delete", null, id);
      await this.$store.dispatch("removeComment", id);
      this.menu = false;
    },
    reportComment(id) {
      this.$store.dispatch("setReport", {
        entityId: id,
        entityName: "comment",
      });
    },
    async getDataComment(page) {
      let data = {
        filter_entityId: this.entityId,
        filter_entityName: "post", // get entity name
        filter_isLatest: "falseOrNull",
        filter_parent: "isNull",
        sort_desc: "createdDate",
        page: page,
      };
      return await this.$store.dispatch("getCommentList", data);
    },
    async onMoreComment(page) {
      let result = await this.getDataComment(page);
      let list = result.list;

      if (list && list.length) {
        this.comments = mergeByKey(this.comments, list, "id");
      }

      if (result.totalPages == 1 || !list.length) this.endData = true;
    },
  },
};
</script>